<app-dialog
  [hideCloseButton]="true"
  [primaryActionText]="okText"
  [isPrimaryActionDestroying]="true"
  [dialogType]="dialogType"
>
  <div id="error-dialog">
    <h4 *ngIf="errorTitle" class="error-title">
      {{ errorTitle }}
    </h4>

    <p *ngIf="errorMessage" class="error-prompt">
      {{ errorMessage }}
    </p>
  </div>
</app-dialog>
